/**
 * Centralized React Query stale time constants.
 * Use these instead of magic numbers to keep cache behavior consistent.
 */
export const STALE_TIMES = {
  auth: 60_000,       // 1 min — user session
  lists: 300_000,     // 5 min — device/rule/schedule lists
  details: 600_000,   // 10 min — detail views
  realtime: 0,        // always refetch
} as const
